import { combineReducers } from 'redux';

export function addToEdit(state = null, action) {
  switch (action.type) {
    case 'PARENT_ADD_TO_EDIT':
      return action.data;
      
      case 'PARENT_ADD_TO_EDIT_RESET':
      return null;

    default:
      return state;  
  }
}

export function updateError(state = null, action) {
  switch (action.type) {
    case 'PARENT_UPDATE_ERROR':
      return action.updateError;

    case 'PARENT_UPDATE_RESET':
      return null;

    default:
      return state;
  }
}

export function updateLoading(state = false, action) {
  switch (action.type) {
    case 'PARENT_UPDATE_LOADING':
      return action.updateLoading;

    case 'PARENT_UPDATE_RESET':
      return false;

    default:
      return state;
  }
}

export function updated(state = null, action) {
  switch (action.type) {
    case 'PARENT_UPDATE_SUCCESS':
      return action.updated;

    case 'PARENT_UPDATE_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({
  updateError,
  updateLoading,
  updated,
  addToEdit,
});
